import template from './sw-category-view.html.twig'

Shopware.Component.override('sw-category-view', {
    template
})
